import { AdminConnection } from '@iobroker/socket-client';

export default AdminConnection;
